import { useState, useEffect, useCallback } from 'react';
import { GxZone, getZones } from '../api/guestExperience';

interface UseGxZonesResult {
  zones: GxZone[];
  isLoading: boolean;
  error: Error | null;
  refetch: () => void;
}

export function useGxZones(eventId: string): UseGxZonesResult {
  const [zones, setZones] = useState<GxZone[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const fetchZones = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const data = await getZones(eventId);
      setZones(data);
    } catch (err) {
      setError(err instanceof Error ? err : new Error(String(err)));
    } finally {
      setIsLoading(false);
    }
  }, [eventId]);

  useEffect(() => {
    fetchZones();
  }, [fetchZones]);

  return { zones, isLoading, error, refetch: fetchZones };
}
